<template>
  <modal name="securone-loss-preview" class="modal-inner" transition="pop-out" :width="620" height="auto" :adaptive="true" :scrollable="true" :focus-trap="true">
    <span class="close-button" @click="cancel"><BaseIcon icon="times-circle" class="text-white" /></span>
    <div class="modal-header text-lg font-serif">{{ $t("securone.loss.title") }}</div>
    <div class="modal-body" v-if="preview">
      <SoNote tone="warn" class="mb-3">{{ $t("securone.loss.intro") }}</SoNote>

      <!-- group side: members dropped, and per member the categories lost -->
      <template v-if="preview.dropped">
        <div v-if="preview.dropped.length" class="mb-3">
          <div class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">{{ $tc("securone.loss.members_dropped", preview.dropped.length, { n: preview.dropped.length }) }}</div>
          <div class="border border-secondary-200 rounded divide-y divide-secondary-100">
            <div v-for="m in preview.dropped" :key="m._id" class="flex items-start gap-3 px-3 py-2 text-sm">
              <SoAvatar :name="m.name" size="sm" />
              <div class="flex-1 min-w-0">
                <div class="text-gray-800">{{ m.name }}</div>
                <div class="text-xs" :class="m.lostCategories.length ? 'text-red-600' : 'text-gray-500'">
                  <template v-if="m.lostCategories.length">{{ $t("securone.loss.loses") }} {{ m.lostCategories.map((c) => c.name).join(", ") }}</template>
                  <template v-else>{{ $t("securone.loss.still_reached") }}</template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="preview.droppedSms && preview.droppedSms.length" class="mb-3">
          <div class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">{{ $tc("securone.loss.sms_dropped", preview.droppedSms.length, { n: preview.droppedSms.length }) }}</div>
          <div class="text-sm text-gray-700">{{ preview.droppedSms.map((c) => c.name).join(", ") }}</div>
        </div>
        <SoNote v-if="!preview.dropped.length && !(preview.droppedSms || []).length" tone="muted">{{ $t("securone.loss.nothing_dropped") }}</SoNote>
      </template>

      <!-- user side: groups dropped and categories lost -->
      <template v-else>
        <div v-if="preview.droppedGroups.length" class="mb-3">
          <div class="text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">{{ $tc("securone.loss.groups_dropped", preview.droppedGroups.length, { n: preview.droppedGroups.length }) }}</div>
          <div class="flex flex-wrap gap-1"><SoChip v-for="g in preview.droppedGroups" :key="g._id">{{ g.name }}</SoChip></div>
        </div>
        <div v-if="preview.lostCategories.length" class="mb-3">
          <div class="text-xxs font-bold uppercase tracking-wide text-red-600 mb-1">{{ $tc("securone.loss.categories_lost", preview.lostCategories.length, { n: preview.lostCategories.length }) }}</div>
          <div class="flex flex-wrap gap-1"><SoChip v-for="c in preview.lostCategories" :key="c._id" tone="live">{{ c.name }}</SoChip></div>
        </div>
        <SoNote v-if="!preview.droppedGroups.length" tone="muted">{{ $t("securone.loss.nothing_dropped") }}</SoNote>
      </template>
    </div>
    <div class="modal-footer">
      <div class="footer-container clearfix">
        <button class="sd-btn sd-btn--secondary float-left" @click="cancel">{{ $t("securone.common.cancel") }}</button>
        <button class="sd-btn sd-btn--warning float-right" @click="confirm">{{ $t("securone.loss.confirm") }}<BaseIcon icon="check" class="ml-1" /></button>
      </div>
    </div>
  </modal>
</template>

<script>
import SoNote from "./SoNote.vue";
import SoChip from "./SoChip.vue";
import SoAvatar from "./SoAvatar.vue";

// V7: nobody loses alarm reach silently. The caller fetches the preview from
// /scope-preview or /departments-preview, shows it here, and saves only after
// the person confirms. open() returns a promise resolving true (confirm) or false.
export default {
  name: "LossPreviewDialog",
  components: { SoNote, SoChip, SoAvatar },
  data() {
    return { preview: null, resolve: null };
  },
  methods: {
    open(preview) {
      this.preview = preview;
      this.$modal.show("securone-loss-preview");
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    finish(value) {
      this.$modal.hide("securone-loss-preview");
      if (this.resolve) this.resolve(value);
      this.resolve = null;
    },
    confirm() {
      this.finish(true);
    },
    cancel() {
      this.finish(false);
    },
  },
};
</script>
